"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_google_maps_1 = require("react-google-maps");
const SearchBox_1 = require("react-google-maps/lib/components/places/SearchBox");
const index_1 = require("./index");
const placeInputStyle = {
    boxSizing: 'border-box',
    MozBoxSizing: 'border-box',
    border: `1px solid transparent`,
    width: 240,
    height: 32,
    marginTop: 5,
    marginLeft: 5,
    padding: `0 12px`,
    borderRadius: `1px`,
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
    fontSize: `14px`,
    outline: `none`,
    textOverflow: `ellipses`,
    cursor: 'text',
};
const RenderMap = react_google_maps_1.withGoogleMap(({ center, bounds, onMapMounted, onBoundsChanged, onCircleDragged, onPlacesChanged, onSearchBoxMounted, radius, zoom, }) => {
    return (React.createElement(react_google_maps_1.GoogleMap, { ref: onMapMounted, center: center, defaultZoom: 16, defaultCenter: { lng: -79.375, lat: 43.65 }, onBoundsChanged: onBoundsChanged, options: {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
        }, zoom: zoom },
        React.createElement(SearchBox_1.default, { ref: onSearchBoxMounted, bounds: bounds, controlPosition: google.maps.ControlPosition.TOP_LEFT, onPlacesChanged: onPlacesChanged },
            React.createElement("input", { type: "text", placeholder: "Enter a place", style: placeInputStyle })),
        React.createElement(react_google_maps_1.Circle, { center: center, radius: radius, options: {
                fillColor: index_1.aquamarine,
                fillOpacity: 0.3,
                strokeColor: index_1.aquamarine,
                strokeOpacity: 1,
                strokeWeight: 2,
            }, draggable: true, onDragEnd: e => onCircleDragged(e) })));
});
class GeofenceInput extends React.Component {
    constructor(props) {
        super(props);
        this._map = undefined;
        this._searchBox = undefined;
        const { latitude, longitude, radius } = props;
        this.state = {
            bounds: null,
            center: new google.maps.LatLng(latitude, longitude),
            radius,
            zoom: Math.round(23 - Math.log(radius) / Math.LN2),
        };
        this.handleMapMounted = this.handleMapMounted.bind(this);
        this.handleBoundsChanged = this.handleBoundsChanged.bind(this);
        this.handleCircleDragged = this.handleCircleDragged.bind(this);
        this.handleSearchBoxMounted = this.handleSearchBoxMounted.bind(this);
        this.handlePlacesChanged = this.handlePlacesChanged.bind(this);
        this.handleRadiusChange = this.handleRadiusChange.bind(this);
    }
    componentDidMount() {
        this.updateValue();
    }
    handleMapMounted(map) {
        this._map = map;
    }
    handleBoundsChanged() {
        this.setState({
            bounds: this._map.getBounds(),
            center: this._map.getCenter(),
        });
    }
    handleCircleDragged({ latLng }) {
        this.setState({ center: latLng }, this.updateValue);
    }
    handleSearchBoxMounted(searchBox) {
        this._searchBox = searchBox;
    }
    handlePlacesChanged() {
        const places = this._searchBox.getPlaces();
        const mapCenter = places.map(({ geometry }) => geometry.location);
        this.setState({ center: mapCenter[0] }, this.updateValue);
    }
    handleRadiusChange(radius) {
        const requiredZoom = Math.round(23 - Math.log(radius) / Math.LN2);
        let zoom = this._map.getZoom();
        if (zoom !== requiredZoom) {
            zoom = requiredZoom;
        }
        this.setState({ radius, zoom }, this.updateValue);
    }
    updateValue() {
        const { handleUpdate } = this.props;
        const { center, radius } = this.state;
        const { lat, lng } = center;
        handleUpdate([lat(), lng(), radius]);
    }
    render() {
        const { device } = this.props;
        const { bounds, center, radius, zoom } = this.state;
        return (React.createElement("div", { style: { width: device === 'Mobile' ? '100%' : 352 } },
            React.createElement(RenderMap, { containerElement: React.createElement("div", { style: {
                        height: 193,
                        width: '100%',
                        marginTop: 16,
                        marginBottom: 16,
                        display: 'inline-block',
                    } }), mapElement: React.createElement("div", { style: { height: '100%' } }), center: center, radius: radius, onMapMounted: this.handleMapMounted, onBoundsChanged: this.handleBoundsChanged, onCircleDragged: this.handleCircleDragged, onSearchBoxMounted: this.handleSearchBoxMounted, bounds: bounds, onPlacesChanged: this.handlePlacesChanged, zoom: zoom }),
            React.createElement(index_1.SliderComponent, { min: 50, max: 500, value: radius, onChange: this.handleRadiusChange, containerStyle: {
                    width: '100%',
                } })));
    }
}
GeofenceInput.defaultProps = {
    latitude: 43.650678,
    longitude: -79.375814,
    radius: 100,
};
exports.default = GeofenceInput;
